import Component from '@glimmer/component';

export default class SvgLogo extends Component {
  <template>
    <div class="flex items-center gap-2" ...attributes>
      <img src="/MADOW.svg" alt="Madow icon" class="{{@imgClass}} chromatic-logo" />
    </div>
  </template>
}
